var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMaccasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 71.75 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my-m 1",
    clipPath: "url(#clip0_0_53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.8343 0C57.4054 0 54.3471 4.73695 52.3466 12.144C50.3461 4.73695 47.284 0 43.8551 0C37.8272 0 32.94 15.7602 32.94 35.1981H37.7908C37.7908 17.1483 40.5056 2.51244 43.8551 2.51244C47.2045 2.51244 49.9195 16.0207 49.9195 32.6823H54.7703C54.7703 16.0207 57.4849 2.51244 60.8343 2.51244C64.1842 2.51244 66.8988 17.1449 66.8988 35.1981H71.7496C71.7496 15.7602 66.8625 0 60.8343 0Z",
    fill: "var(--fill-0, #FFBC0D)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-3.71881e-06 25.7276L1.81202 8.93917H6.04115L9.42382 19.4894L12.8329 8.93917H17.0621L18.8741 25.7276H14.5524L13.61 15.4791L10.7332 24.5005H8.05158L5.15169 15.3797L4.18615 25.7276H-3.71881e-06ZM19.8198 30.6874L20.6663 28.0824C21.1656 28.2983 21.6582 28.408 22.141 28.408C22.5114 28.408 22.8453 28.2915 23.1429 28.0584C23.4405 27.8253 23.7414 27.3489 24.0489 26.6291L24.5086 25.5254L19.7966 13.0969H24.0522L26.3735 21.066L28.622 13.0969H32.6097L27.4349 26.8039C26.8562 28.3395 26.1784 29.4774 25.4046 30.2109C24.6309 30.9444 23.6951 31.3146 22.6006 31.3146C22.0352 31.3146 21.5194 31.2598 21.0531 31.1501C20.5869 31.0438 20.1736 30.8896 19.8198 30.6874Z",
    fill: "url(#paint0_linear_0_53)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_53",
    x1: -0.00000371881,
    y1: 20.1269,
    x2: 32.6078,
    y2: 20.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000616698,
    stopColor: "#910063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0362,
    stopColor: "#990059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1727,
    stopColor: "#B60035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    stopColor: "#CA001C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#D7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#DB0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8720A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.75,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMaccasLogo);
export default __webpack_public_path__ + "static/media/my-maccas-logo.fa1283e2ae02d5ac6ab1c8a8aea7af1b.svg";
export { ForwardRef as ReactComponent };